import React, { useState, useEffect, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
import IconButton from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

const animationIn = keyframes`
  from { top: -25px; }
  to { top: 0; }
`;
const Root = styled.div`
  animation: ${animationIn} 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
  ${({ show }) => !show && 'animation-direction: reverse;'}

  position: absolute;
  left: 0;
  top: -25px;
  width: 100%;
  background-color: rgba(255, 0, 0, 0.5);
  color: white;
  z-index: 10000;
  backdrop-filter: blur(4px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const ButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: -7px;
`;
const CloseButton = styled(IconButton).attrs({
  size: 'small',
})`
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
`;

const ghostedUsername = window.sessionStorage.getItem(
  'trueimpact.ghostedUsername',
);
const isLocalhost = window.location.hostname === 'localhost';
const isUAT = window.location.hostname === 'uat.trueimpact.com';
const isAPP = window.location.hostname === 'app.trueimpact.com';

const shouldHideBanner =
  localStorage.getItem('DO_NOT_SHOW_SERVICE_BANNER') === '1' ||
  isLocalhost ||
  isUAT ||
  isAPP;

const defaultValue = import.meta.env.VITE_HIDE_STATUS_BANNER !== 'true';
export default function ServerNotice() {
  const [deployInfo, setDeployInfo] = useState();
  const [show, setShow] = useState(defaultValue);
  const [render, setRender] = useState(defaultValue);

  useEffect(() => {
    let active = true;

    (async () => {
      if (!isLocalhost) {
        const resDeploy = await fetch('/deploy.txt');

        if (active) {
          setDeployInfo(await resDeploy.text());
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [setDeployInfo]);

  const handleClose = useCallback(() => {
    setShow(false);
    let timeout = setTimeout(() => {
      setRender(false);
      timeout = null;
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [setShow, setRender]);

  if (!render || shouldHideBanner || ghostedUsername !== null) {
    return null;
  }

  return (
    <Root {...{ show }}>
      <ButtonContainer>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </ButtonContainer>
    </Root>
  );
}
